module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/historic heritage-2e3e889a07031fe31fca329bbf9b5629.png";